"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DT = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _Text = require("../Text");

var DT = function DT(props) {
  return /*#__PURE__*/_react["default"].createElement(_Text.Text, (0, _extends2["default"])({
    El: "dt",
    color: "muted",
    truncate: true
  }, props));
};

exports.DT = DT;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJEVCIsInByb3BzIl0sInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvRGF0YUxpc3QvRFQudHN4Il0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5cbmltcG9ydCB7IFRleHQgfSBmcm9tICcuLi9UZXh0JztcblxuZXhwb3J0IGNvbnN0IERUID0gKHByb3BzOiBSZWFjdC5Db21wb25lbnRQcm9wczx0eXBlb2YgVGV4dD4pID0+IChcbiAgPFRleHQgRWw9XCJkdFwiIGNvbG9yPVwibXV0ZWRcIiB0cnVuY2F0ZSB7Li4ucHJvcHN9IC8+XG4pO1xuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7OztBQUFBOztBQUVBOztBQUVPLElBQU1BLEVBQUUsR0FBRyxTQUFMQSxFQUFLLENBQUNDLEtBQUQ7RUFBQSxvQkFDaEIsZ0NBQUMsVUFBRDtJQUFNLEVBQUUsRUFBQyxJQUFUO0lBQWMsS0FBSyxFQUFDLE9BQXBCO0lBQTRCLFFBQVE7RUFBcEMsR0FBeUNBLEtBQXpDLEVBRGdCO0FBQUEsQ0FBWCJ9